export const EXPRESSION_DATA = [
  {
    nodeId: '1',
    label: 'SmartSolve',
    description: '',
    value: '',
    usage: '',
    childNodes: [
      {
        nodeId: '2',
        label: 'Current User',
        usage: '',
        value: '',
        description: '',
        childNodes: [
          {
            nodeId: '3',
            label: 'Actor Code',
            usage: 'Code.GetUserDetail("ActorCode")',
            description: '',
            value: 'Code.GetUserDetail("ActorCode")',
            childNodes: [],
          },
          {
            nodeId: '4',
            label: 'Department / Org Unit',
            usage: 'Code.GetUserDetail("OrgUnitCode")',
            description: '',
            value: 'Code.GetUserDetail("OrgUnitCode")',
            childNodes: [],
          },
          {
            nodeId: '5',
            label: 'LoggedOn Organization',
            usage: 'Code.GetUserDetail("LoggedOnOrgCode")',
            description: '',
            value: 'Code.GetUserDetail("LoggedOnOrgCode")',
            childNodes: [],
          },
          {
            nodeId: '6',
            label: 'Login',
            usage: 'Code.GetUserDetail("UserCode")',
            description: '',
            value: 'Code.GetUserDetail("UserCode")',
            childNodes: [],
          },
          {
            nodeId: '7',
            label: 'Role Code',
            usage: 'Code.GetUserDetail("RoleCode")',
            description: '',
            value: 'Code.GetUserDetail("RoleCode")',
            childNodes: [],
          },
          {
            nodeId: '8',
            label: 'Role Name',
            usage: 'Code.GetUserDetail("RoleName")',
            description: '',
            value: 'Code.GetUserDetail("RoleName")',
            childNodes: [],
          },
          {
            nodeId: '9',
            label: 'Site Code',
            usage: 'Code.GetUserDetail("SiteCode")',
            description: '',
            value: 'Code.GetUserDetail("SiteCode")',
            childNodes: [],
          },
          {
            nodeId: '10',
            label: 'Site Name',
            usage: 'Code.GetUserDetail("SiteName")',
            description: '',
            value: 'Code.GetUserDetail("SiteName")',
            childNodes: [],
          },
          {
            nodeId: '10',
            label: 'Title',
            usage: 'Code.GetUserDetail("ActorTitle")',
            description: '',
            value: 'Code.GetUserDetail("ActorTitle")',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '12',
        label: 'Strip HTML Tags',
        usage: 'Code.StripTags([expression])',
        value: 'Code.StripTags([expression])',
        description: '',
        childNodes: [],
      },
      {
        nodeId: '13',
        label: 'Translate string',
        usage: 'Code.TranslateString([expression])',
        value: 'Code.TranslateString([expression])',
        description: '',
        childNodes: [],
      },
    ],
  },
  {
    nodeId: '14',
    label: 'Hyperlinks',
    description: '',
    value: '',
    usage: '',
    childNodes: [
      {
        nodeId: '15',
        label: 'SmartSolve URL',
        usage: 'Code.GetSmartSolveUrl()',
        value: 'Code.GetSmartSolveUrl()',
        description: '',
        childNodes: [],
      },
      {
        nodeId: '16',
        label: 'Launch Report URL',
        usage: 'Code.GetLaunchReportURL([reportName],[queryParams])',
        value: 'Code.GetLaunchReportURL([reportName],[queryParams])',
        description: '',
        childNodes: [],
      },
      {
        nodeId: '17',
        label: 'Current Application URL',
        usage: 'Code.GetReportApplicationURL([RelativePath])',
        value: 'Code.GetReportApplicationURL([RelativePath])',
        description: '',
        childNodes: [],
      },
      {
        nodeId: '18',
        label: 'SmartSolve Detail Pages',
        usage: '',
        value: '',
        description: '',
        childNodes: [
          {
            nodeId: '19',
            label: 'Internal Actor',
            usage: 'Code.BuildSmartSolveUrl("InternalActor",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("InternalActor",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '20',
            label: 'Audit',
            usage: 'Code.BuildSmartSolveUrl("Audit",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("Audit",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '21',
            label: 'Audit Program',
            usage: 'Code.BuildSmartSolveUrl("AuditProgram",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("AuditProgram",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '22',
            label: 'Company Form',
            usage: 'Code.BuildSmartSolveUrl("CompanyForm",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("CompanyForm",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '23',
            label: 'Complaint',
            usage: 'Code.BuildSmartSolveUrl("Complaint",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("Complaint",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '24',
            label: 'Criteria',
            usage: 'Code.BuildSmartSolveUrl("Criteria",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("Criteria",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '25',
            label: 'Document',
            usage: 'Code.BuildSmartSolveUrl("SmartDocument",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("SmartDocument",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '25',
            label: 'General Exception',
            usage: 'Code.BuildSmartSolveUrl("GeneralException",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("GeneralException",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '26',
            label: 'Issue',
            usage: 'Code.BuildSmartSolveUrl("Issue",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("Issue",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '27',
            label: 'Person',
            usage: 'Code.BuildSmartSolveUrl("Person",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("Person",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '28',
            label: 'Process Exception',
            usage: 'Code.BuildSmartSolveUrl("ProcessException",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("ProcessException",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '29',
            label: 'ProductException',
            usage: 'Code.BuildSmartSolveUrl("ProductException",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("ProductException",[ItemId])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '30',
            label: 'Training Session',
            usage: 'Code.BuildSmartSolveUrl("Training",[ItemId])',
            value: 'Code.BuildSmartSolveUrl("Training",[ItemId])',
            description: '',
            childNodes: [],
          },
        ],
      },
    ],
  },
  {
    nodeId: '31',
    label: 'Operators',
    description: '',
    value: '',
    usage: '',
    childNodes: [
      {
        nodeId: '32',
        label: 'Arithmetic',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '33',
            label: 'Add',
            usage: '+',
            value: '+',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '34',
            label: 'Substract',
            usage: '-',
            value: '-',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '35',
            label: 'Multiply',
            usage: '*',
            value: '*',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '36',
            label: 'Divide',
            usage: '/',
            value: '/',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '37',
            label: 'Mode',
            usage: 'Mod',
            value: 'Mod',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '38',
            label: 'Power',
            usage: '^',
            value: '^',
            description: '',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '39',
        label: 'Comparison',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '40',
            label: 'Less Than',
            usage: '<',
            value: '<',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '41',
            label: 'Less Than Equal To',
            usage: '<=',
            value: '<=',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '42',
            label: 'Greater Than',
            usage: '>',
            value: '>',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '43',
            label: 'Less Than Equal To',
            usage: '>=',
            value: '>=',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '44',
            label: 'Equal',
            usage: '=',
            value: '=',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '45',
            label: 'Not Equal',
            usage: '!=',
            value: '!=',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '46',
            label: 'Like',
            usage: 'Like',
            value: 'Like',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '47',
            label: 'Is',
            usage: 'Is',
            value: 'Is',
            description: '',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '48',
        label: 'Concatenation',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '49',
            label: 'And',
            usage: '&',
            value: '&',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '50',
            label: 'Plus',
            usage: '+',
            value: '+',
            description: '',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '51',
        label: 'Logical/Bitwise',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '52',
            label: 'And',
            usage: 'And',
            value: 'And',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '53',
            label: 'Not',
            usage: 'Not([expression])',
            value: 'Not([expression])',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '54',
            label: 'Or',
            usage: 'Or',
            value: 'Or',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '54',
            label: 'Xor',
            usage: 'Xor',
            value: 'Xor',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '54',
            label: 'Xor',
            usage: 'Xor',
            value: 'Xor',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '55',
            label: 'AndAlso',
            usage: 'AndAlso',
            value: 'AndAlso',
            description: '',
            childNodes: [],
          },
          {
            nodeId: '55',
            label: 'OrElse',
            usage: 'OrElse',
            value: 'OrElse',
            description: '',
            childNodes: [],
          },
        ],
      },
    ],
  },
  {
    nodeId: '56',
    label: 'Common Functions',
    description: '',
    value: '',
    usage: '',
    childNodes: [
      {
        nodeId: '57',
        label: 'Text',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '58',
            label: 'Asc',
            description: '',
            value: 'Asc([expression])',
            usage: 'Asc([expression])',
            childNodes: [],
          },
          {
            nodeId: '59',
            label: 'AscW',
            description: '',
            value: 'AscW([expression])',
            usage: 'AscW([expression])',
            childNodes: [],
          },
          {
            nodeId: '60',
            label: 'Chr',
            description: '',
            value: 'Chr([CharacterCode])',
            usage: 'Chr([CharacterCode])',
            childNodes: [],
          },
          {
            nodeId: '61',
            label: 'ChrW',
            description: '',
            value: 'ChrW([CharacterCode])',
            usage: 'ChrW([CharacterCode])',
            childNodes: [],
          },
          {
            nodeId: '62',
            label: 'Filter',
            description: '',
            value: 'Filter([expression], [MatchString], [Include], [CompareMethod])',
            usage: 'Filter([expression], [MatchString], [Include], [CompareMethod])',
            childNodes: [],
          },
          {
            nodeId: '63',
            label: 'Format',
            description: '',
            value: 'Format([expression], [Style])',
            usage: 'Format([expression], [Style])',
            childNodes: [],
          },
          {
            nodeId: '64',
            label: 'FormatCurrency',
            description: '',
            value:
              'FormatCurrency([expression], [NumDigitsAfterDecimal], [IncludeLeadingDigit], [UseParanthesisForNegativeNumber], [GroupDigits])',
            usage:
              'FormatCurrency([expression], [NumDigitsAfterDecimal], [IncludeLeadingDigit], [UseParanthesisForNegativeNumber], [GroupDigits])',
            childNodes: [],
          },
          {
            nodeId: '65',
            label: 'FormatDateTime',
            description: '',
            value: 'FormatDateTime([expression], [DateFormat])',
            usage: 'FormatDateTime([expression], [DateFormat])',
            childNodes: [],
          },
          {
            nodeId: '66',
            label: 'FormatNumber',
            description: '',
            value:
              'FormatNumber([expression], [NumDigitsAfterDecimal], [IncludeLeadingDigit], [UseParanthesisForNegativeNumber], [GroupDigits])',
            usage:
              'FormatNumber([expression], [NumDigitsAfterDecimal], [IncludeLeadingDigit], [UseParanthesisForNegativeNumber], [GroupDigits])',
            childNodes: [],
          },
          {
            nodeId: '67',
            label: 'FormatPercent',
            description: '',
            value:
              'FormatPercent([expression], [NumDigitsAfterDecimal], [IncludeLeadingDigit], [UseParanthesisForNegativeNumber], [GroupDigits])',
            usage:
              'FormatPercent([expression], [NumDigitsAfterDecimal], [IncludeLeadingDigit], [UseParanthesisForNegativeNumber], [GroupDigits])',
            childNodes: [],
          },
          {
            nodeId: '68',
            label: 'GetChar',
            description: '',
            value: 'GetChar([expression], [Index])',
            usage: 'GetChar([expression], [Index])',
            childNodes: [],
          },
          {
            nodeId: '69',
            label: 'InStr',
            description: '',
            value: 'InStr([expression], [expression], [Number])',
            usage: 'InStr([expression], [expression], [Number])',
            childNodes: [],
          },
          {
            nodeId: '70',
            label: 'InStrRev',
            description: '',
            value: 'InStrRev([expression], [Match], [Start], [CompareMethod])',
            usage: 'InStrRev([expression], [Match], [Start], [CompareMethod])',
            childNodes: [],
          },
          {
            nodeId: '71',
            label: 'Join',
            description: '',
            value: 'Join([Source], [Delimiter])',
            usage: 'Join([Source], [Delimiter])',
            childNodes: [],
          },
          {
            nodeId: '72',
            label: 'LCase',
            description: '',
            value: 'LCase([expression])',
            usage: 'LCase([expression])',
            childNodes: [],
          },
          {
            nodeId: '73',
            label: 'Left',
            description: '',
            value: 'Left([expression], [Number])',
            usage: 'Left([expression], [Number])',
            childNodes: [],
          },
          {
            nodeId: '74',
            label: 'Len',
            description: '',
            value: 'Len([expression])',
            usage: 'Len([expression])',
            childNodes: [],
          },
          {
            nodeId: '75',
            label: 'LSet',
            description: '',
            value: 'LSet([expression], [Number])',
            usage: 'LSet([expression], [Number])',
            childNodes: [],
          },
          {
            nodeId: '76',
            label: 'LTrim',
            description: '',
            value: 'LTrim([expression])',
            usage: 'LTrim([expression])',
            childNodes: [],
          },
          {
            nodeId: '77',
            label: 'Mid',
            description: '',
            value: 'Mid([expression], [Start], [Length])',
            usage: 'Mid([expression], [Start], [Length])',
            childNodes: [],
          },
          {
            nodeId: '78',
            label: 'Replace',
            description: '',
            value:
              'Replace([expression], [FindString], [Replacement], [Start], [Count], [CompareMethod])',
            usage:
              'Replace([expression], [FindString], [Replacement], [Start], [Count], [CompareMethod])',
            childNodes: [],
          },
          {
            nodeId: '79',
            label: 'Right',
            description: '',
            value: 'Right([expression], [Number])',
            usage: 'Right([expression], [Number])',
            childNodes: [],
          },
          {
            nodeId: '80',
            label: 'RSet',
            description: '',
            value: 'RSet([expression], [Number])',
            usage: 'RSet([expression], [Number])',
            childNodes: [],
          },
          {
            nodeId: '81',
            label: 'RTrim',
            description: '',
            value: 'RTrim([expression])',
            usage: 'RTrim([expression])',
            childNodes: [],
          },
          {
            nodeId: '82',
            label: 'Space',
            description: '',
            value: 'Space([Number])',
            usage: 'Space([Number])',
            childNodes: [],
          },
          {
            nodeId: '83',
            label: 'Split',
            description: '',
            value: 'Split([expression], [Delimiter], [Limit], [CompareMethod])',
            usage: 'Split([expression], [Delimiter], [Limit], [CompareMethod])',
            childNodes: [],
          },
          {
            nodeId: '84',
            label: 'StrComp',
            description: '',
            value: 'StrComp([expression], [expression], [CompareMethod])',
            usage: 'StrComp([expression], [expression], [CompareMethod])',
            childNodes: [],
          },
          {
            nodeId: '85',
            label: 'StrConv',
            description: '',
            value: 'StrConv([expression], [Conversion])',
            usage: 'StrConv([expression], [Conversion])',
            childNodes: [],
          },
          {
            nodeId: '86',
            label: 'StrDup',
            description: '',
            value: 'StrDup([Number], [Character])',
            usage: 'StrDup([Number], [Character])',
            childNodes: [],
          },
          {
            nodeId: '87',
            label: 'StrReverse',
            description: '',
            value: 'StrReverse([expression])',
            usage: 'StrReverse([expression])',
            childNodes: [],
          },
          {
            nodeId: '88',
            label: 'Trim',
            description: '',
            value: 'Trim([expression])',
            usage: 'Trim([expression])',
            childNodes: [],
          },
          {
            nodeId: '89',
            label: 'UCase',
            description: '',
            value: 'UCase([expression])',
            usage: 'UCase([expression])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '90',
        label: 'Date & Time',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '91',
            label: 'Beggining Of Month',
            description: '',
            value: 'Code.BOM([Date])',
            usage: 'Code.BOM([Date])',
            childNodes: [],
          },
          {
            nodeId: '92',
            label: 'Convert To Date',
            description: '',
            value: 'CDate([expression])',
            usage: 'CDate([expression])',
            childNodes: [],
          },
          {
            nodeId: '93',
            label: 'Convert To Local Date',
            description: '',
            value: 'Code.ConvertToLocalDateTime([Date])',
            usage: 'Code.ConvertToLocalDateTime([Date])',
            childNodes: [],
          },
          {
            nodeId: '94',
            label: 'Convert To Server Date',
            description: '',
            value: 'Code.ConvertToLocalServerTime([Date])',
            usage: 'Code.ConvertToLocalServerTime([Date])',
            childNodes: [],
          },
          {
            nodeId: '95',
            label: 'Add/Subtract Days',
            description: '',
            value: 'DateAdd(DateInterval.Day, [NumberOfDays], [Date])',
            usage: 'DateAdd(DateInterval.Day, [NumberOfDays], [Date])',
            childNodes: [],
          },
          {
            nodeId: '96',
            label: 'Date Part',
            description: '',
            value: 'DatePart([DateInterval], [DateValue], [FirstDayOfWeek], [FirstWeekOfYear])',
            usage: 'DatePart([DateInterval], [DateValue], [FirstDayOfWeek], [FirstWeekOfYear])',
            childNodes: [],
          },
          {
            nodeId: '97',
            label: 'Date Serial',
            description: '',
            value: 'DateSerial([Year], [Month], [Day])',
            usage: 'DateSerial([Year], [Month], [Day])',
            childNodes: [],
          },
          {
            nodeId: '98',
            label: 'Date String',
            description: '',
            value: 'DateString()',
            usage: 'DateString()',
            childNodes: [],
          },
          {
            nodeId: '99',
            label: 'Date Value',
            description: '',
            value: 'DateValue([expression])',
            usage: 'DateValue([expression])',
            childNodes: [],
          },
          {
            nodeId: '100',
            label: 'Day',
            description: '',
            value: 'Day([Date])',
            usage: 'Day([Date])',
            childNodes: [],
          },
          {
            nodeId: '101',
            label: 'Elapsed Days',
            description: '',
            value: 'DateDiff(DateInterval.Day, [ToDate], [FromDate])',
            usage: 'DateDiff(DateInterval.Day, [ToDate], [FromDate])',
            childNodes: [],
          },
          {
            nodeId: '102',
            label: 'End Of Month',
            description: '',
            value: 'Code.EOM([Date])',
            usage: 'Code.EOM([Date])',
            childNodes: [],
          },
          {
            nodeId: '103',
            label: 'Hour',
            description: '',
            value: 'Hour([Date])',
            usage: 'Hour([Date])',
            childNodes: [],
          },
          {
            nodeId: '104',
            label: 'Minute',
            description: '',
            value: 'Minute([Date])',
            usage: 'Minute([Date])',
            childNodes: [],
          },
          {
            nodeId: '105',
            label: 'Month Number',
            description: '',
            value: 'Month([Date])',
            usage: 'Month([Date])',
            childNodes: [],
          },
          {
            nodeId: '106',
            label: 'Month Name',
            description: '',
            value: 'MonthName(Month([Date]))',
            usage: 'MonthName(Month([Date]))',
            childNodes: [],
          },
          {
            nodeId: '107',
            label: 'Now',
            description: '',
            value: 'Now()',
            usage: 'Now()',
            childNodes: [],
          },
          {
            nodeId: '108',
            label: 'Second',
            description: '',
            value: 'Second([Date])',
            usage: 'Second([Date])',
            childNodes: [],
          },
          {
            nodeId: '109',
            label: 'TimeOfDay',
            description: '',
            value: 'TimeOfDay()',
            usage: 'TimeOfDay()',
            childNodes: [],
          },
          {
            nodeId: '110',
            label: 'Timer',
            description: '',
            value: 'Timer()',
            usage: 'Timer()',
            childNodes: [],
          },
          {
            nodeId: '111',
            label: 'TimeSerial',
            description: '',
            value: 'TimeSerial([Hour], [Minute], [Second])',
            usage: 'TimeSerial([Hour], [Minute], [Second])',
            childNodes: [],
          },
          {
            nodeId: '112',
            label: 'TimeString',
            description: '',
            value: 'TimeString()',
            usage: 'TimeString()',
            childNodes: [],
          },
          {
            nodeId: '113',
            label: 'TimeValue',
            description: '',
            value: 'TimeValue([expression])',
            usage: 'TimeValue([expression])',
            childNodes: [],
          },
          {
            nodeId: '114',
            label: 'Today',
            description: '',
            value: 'Today()',
            usage: 'Today()',
            childNodes: [],
          },
          {
            nodeId: '115',
            label: 'Weekday',
            description: '',
            value: 'Weekday([Date], [FirstDayOfWeek])',
            usage: 'Weekday([Date], [FirstDayOfWeek])',
            childNodes: [],
          },
          {
            nodeId: '116',
            label: 'WeekdayName',
            description: '',
            value: 'WeekdayName([WeekDay], [Abbreviate], [FirstDayOfWeek])',
            usage: 'WeekdayName([WeekDay], [Abbreviate], [FirstDayOfWeek])',
            childNodes: [],
          },
          {
            nodeId: '116',
            label: 'Year',
            description: '',
            value: 'Year([Date])',
            usage: 'Year([Date])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '117',
        label: 'Math',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '118',
            label: 'Abs',
            description: '',
            value: 'Abs([expression])',
            usage: 'Abs([expression])',
            childNodes: [],
          },
          {
            nodeId: '119',
            label: 'Acos',
            description: '',
            value: 'Acos([expression])',
            usage: 'Acos([expression])',
            childNodes: [],
          },
          {
            nodeId: '120',
            label: 'Asin',
            description: '',
            value: 'Asin([expression])',
            usage: 'Asin([expression])',
            childNodes: [],
          },
          {
            nodeId: '121',
            label: 'Atan',
            description: '',
            value: 'Atan([expression])',
            usage: 'Atan([expression])',
            childNodes: [],
          },
          {
            nodeId: '122',
            label: 'Atan2',
            description: '',
            value: 'Atan2([expression], [expression])',
            usage: 'Atan2([expression], [expression])',
            childNodes: [],
          },
          {
            nodeId: '123',
            label: 'BigMul',
            description: '',
            value: 'BigMul([expression], [expression])',
            usage: 'BigMul([expression], [expression])',
            childNodes: [],
          },
          {
            nodeId: '124',
            label: 'BigMul',
            description: '',
            value: 'BigMul([expression], [expression])',
            usage: 'BigMul([expression], [expression])',
            childNodes: [],
          },
          {
            nodeId: '125',
            label: 'Ceiling',
            description: '',
            value: 'Ceiling([expression])',
            usage: 'Ceiling([expression])',
            childNodes: [],
          },
          {
            nodeId: '126',
            label: 'Cos',
            description: '',
            value: 'Cos([expression])',
            usage: 'Cos([expression])',
            childNodes: [],
          },
          {
            nodeId: '127',
            label: 'Cosh',
            description: '',
            value: 'Cosh([expression])',
            usage: 'Cosh([expression])',
            childNodes: [],
          },
          {
            nodeId: '128',
            label: 'Exp',
            description: '',
            value: 'Exp([expression])',
            usage: 'Exp([expression])',
            childNodes: [],
          },
          {
            nodeId: '129',
            label: 'Fix',
            description: '',
            value: 'Fix([expression])',
            usage: 'Fix([expression])',
            childNodes: [],
          },
          {
            nodeId: '130',
            label: 'Floor',
            description: '',
            value: 'Floor([expression])',
            usage: 'Floor([expression])',
            childNodes: [],
          },
          {
            nodeId: '131',
            label: 'Int',
            description: '',
            value: 'Int([expression])',
            usage: 'Int([expression])',
            childNodes: [],
          },
          {
            nodeId: '132',
            label: 'Log',
            description: '',
            value: 'Log([expression])',
            usage: 'Log([expression])',
            childNodes: [],
          },
          {
            nodeId: '133',
            label: 'Log10',
            description: '',
            value: 'Log10([expression])',
            usage: 'Log10([expression])',
            childNodes: [],
          },
          {
            nodeId: '134',
            label: 'Max',
            description: '',
            value: 'Max([expression], [Scope], [Recursive])',
            usage: 'Max([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '135',
            label: 'Min',
            description: '',
            value: 'Min([expression], [Scope], [Recursive])',
            usage: 'Min([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '136',
            label: 'Pow',
            description: '',
            value: 'Pow([expression], [expression])',
            usage: 'Pow([expression], [expression])',
            childNodes: [],
          },
          {
            nodeId: '137',
            label: 'Rnd',
            description: '',
            value: 'Rnd([expression])',
            usage: 'Rnd([expression])',
            childNodes: [],
          },
          {
            nodeId: '138',
            label: 'Round',
            description: '',
            value: 'Round([expression])',
            usage: 'Round([expression])',
            childNodes: [],
          },
          {
            nodeId: '139',
            label: 'Sign',
            description: '',
            value: 'Sign([expression])',
            usage: 'Sign([expression])',
            childNodes: [],
          },
          {
            nodeId: '140',
            label: 'Sin',
            description: '',
            value: 'Sin([expression])',
            usage: 'Sin([expression])',
            childNodes: [],
          },
          {
            nodeId: '141',
            label: 'Sinh',
            description: '',
            value: 'Sinh([expression])',
            usage: 'Sinh([expression])',
            childNodes: [],
          },
          {
            nodeId: '142',
            label: 'Sqrt',
            description: '',
            value: 'Sqrt([expression])',
            usage: 'Sqrt([expression])',
            childNodes: [],
          },
          {
            nodeId: '143',
            label: 'Tan',
            description: '',
            value: 'Tan([expression])',
            usage: 'Tan([expression])',
            childNodes: [],
          },
          {
            nodeId: '144',
            label: 'Tanh',
            description: '',
            value: 'Tanh([expression])',
            usage: 'Tanh([expression])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '145',
        label: 'Inspection',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '146',
            label: 'IsArray',
            description: '',
            value: 'IsArray([expression])',
            usage: 'IsArray([expression])',
            childNodes: [],
          },
          {
            nodeId: '147',
            label: 'IsDate',
            description: '',
            value: 'IsDate([expression])',
            usage: 'IsDate([expression])',
            childNodes: [],
          },
          {
            nodeId: '148',
            label: 'IsNothing',
            description: '',
            value: 'IsNothing([expression])',
            usage: 'IsNothing([expression])',
            childNodes: [],
          },
          {
            nodeId: '149',
            label: 'IsNumeric',
            description: '',
            value: 'IsNumeric([expression])',
            usage: 'IsNumeric([expression])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '150',
        label: 'Program Flow',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '151',
            label: 'Choose',
            description: '',
            value: 'Choose([Index], [expression], [expression], ...)',
            usage: 'Choose([Index], [expression], [expression], ...)',
            childNodes: [],
          },
          {
            nodeId: '152',
            label: 'IIF',
            description: '',
            value: 'IIF([expression], [TruePart], [FalsePart])',
            usage: 'IIF([expression], [TruePart], [FalsePart])',
            childNodes: [],
          },
          {
            nodeId: '153',
            label: 'Switch',
            description: '',
            value: 'Switch([expression])',
            usage: 'Switch([expression])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '154',
        label: 'Aggregate',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '155',
            label: 'Avg',
            description: '',
            value: 'Avg([expression], [Scope], [Recursive])',
            usage: 'Avg([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '156',
            label: 'Count',
            description: '',
            value: 'Count([expression])',
            usage: 'Count([expression])',
            childNodes: [],
          },
          {
            nodeId: '157',
            label: 'CountDistinct',
            description: '',
            value: 'CountDistinct([expression])',
            usage: 'CountDistinct([expression])',
            childNodes: [],
          },
          {
            nodeId: '158',
            label: 'CountRows',
            description: '',
            value: 'CountRows()',
            usage: 'CountRows()',
            childNodes: [],
          },
          {
            nodeId: '159',
            label: 'CountRFirstows',
            description: '',
            value: 'First([expression])',
            usage: 'First([expression])',
            childNodes: [],
          },
          {
            nodeId: '160',
            label: 'Last',
            description: '',
            value: 'Last([expression])',
            usage: 'Last([expression])',
            childNodes: [],
          },
          {
            nodeId: '161',
            label: 'Max',
            description: '',
            value: 'Max([expression], [Scope], [Recursive])',
            usage: 'Max([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '162',
            label: 'Min',
            description: '',
            value: 'Min([expression], [Scope], [Recursive])',
            usage: 'Min([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '163',
            label: 'StDev',
            description: '',
            value: 'StDev([expression])',
            usage: 'StDev([expression])',
            childNodes: [],
          },
          {
            nodeId: '164',
            label: 'StDevP',
            description: '',
            value: 'StDevP([expression])',
            usage: 'StDevP([expression])',
            childNodes: [],
          },
          {
            nodeId: '165',
            label: 'Sum',
            description: '',
            value: 'Sum([expression])',
            usage: 'Sum([expression])',
            childNodes: [],
          },
          {
            nodeId: '166',
            label: 'Var',
            description: '',
            value: 'Var([expression], [Scope], [Recursive])',
            usage: 'Var([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '167',
            label: 'VarP',
            description: '',
            value: 'VarP([expression], [Scope], [Recursive])',
            usage: 'VarP([expression], [Scope], [Recursive])',
            childNodes: [],
          },
          {
            nodeId: '168',
            label: 'RunningValue',
            description: '',
            value: 'RunningValue([expression], [Function], [Scope])',
            usage: 'RunningValue([expression], [Function], [Scope])',
            childNodes: [],
          },
          {
            nodeId: '169',
            label: 'RunningValue',
            description: '',
            value: 'RunningValue([expression], [Function], [Scope])',
            usage: 'RunningValue([expression], [Function], [Scope])',
            childNodes: [],
          },
          {
            nodeId: '170',
            label: 'Aggregate',
            description: '',
            value: 'Aggregate([expression])',
            usage: 'Aggregate([expression])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '171',
        label: 'Financial',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '172',
            label: 'DDB',
            description: '',
            value: 'DDB([Cost], [Salvage], [Life], [Period], [Factor])',
            usage: 'DDB([Cost], [Salvage], [Life], [Period], [Factor])',
            childNodes: [],
          },
          {
            nodeId: '173',
            label: 'FV',
            description: '',
            value: 'FV([Rate], [Per], [NPer], [Pmt], [PV], [FV], [DueDate])',
            usage: 'FV([Rate], [Per], [NPer], [Pmt], [PV], [FV], [DueDate])',
            childNodes: [],
          },
          {
            nodeId: '174',
            label: 'IPmt',
            description: '',
            value: 'IPmt([Rate], [NPer], [Pmt], [PV], [DueDate])',
            usage: 'IPmt([Rate], [NPer], [Pmt], [PV], [DueDate])',
            childNodes: [],
          },
          {
            nodeId: '175',
            label: 'NPer',
            description: '',
            value: 'NPer([Rate], [Pmt], [PV], [FV], [DueDate])',
            usage: 'NPer([Rate], [Pmt], [PV], [FV], [DueDate])',
            childNodes: [],
          },
          {
            nodeId: '176',
            label: 'Pmt',
            description: '',
            value: 'Pmt([Rate],[NPer], [PV], [FV], [DueDate])',
            usage: 'Pmt([Rate],[NPer], [PV], [FV], [DueDate])',
            childNodes: [],
          },
          {
            nodeId: '177',
            label: 'PPmt',
            description: '',
            value: 'PPmt([Rate], [Per], [NPer], [PV], [FV], [DueDate])',
            usage: 'PPmt([Rate], [Per], [NPer], [PV], [FV], [DueDate])',
            childNodes: [],
          },
          {
            nodeId: '178',
            label: 'PV',
            description: '',
            value: 'PV([Rate], [NPer], [Pmt], [FV], [DueDate])',
            usage: 'PV([Rate], [NPer], [Pmt], [FV], [DueDate])',
            childNodes: [],
          },
          {
            nodeId: '179',
            label: 'Rate',
            description: '',
            value: 'Rate([NPer], [Pmt], [PV], [FV], [DueDate], [Guess])',
            usage: 'Rate([NPer], [Pmt], [PV], [FV], [DueDate], [Guess])',
            childNodes: [],
          },
          {
            nodeId: '180',
            label: 'SLN',
            description: '',
            value: 'SLN([Cost], [Salvage], [Life])',
            usage: 'SLN([Cost], [Salvage], [Life])',
            childNodes: [],
          },
          {
            nodeId: '181',
            label: 'SYD',
            description: '',
            value: 'SYD([Cost], [Salvage], [Life], [Period])',
            usage: 'SYD([Cost], [Salvage], [Life], [Period])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '182',
        label: 'Conversion',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '182',
            label: 'Convert To Boolean',
            description: '',
            value: 'CBool([expression])',
            usage: 'CBool([expression])',
            childNodes: [],
          },
          {
            nodeId: '183',
            label: 'Convert To Byte',
            description: '',
            value: 'CByte([expression])',
            usage: 'CByte([expression])',
            childNodes: [],
          },
          {
            nodeId: '184',
            label: 'Convert To Char',
            description: '',
            value: 'CChar([expression])',
            usage: 'CChar([expression])',
            childNodes: [],
          },
          {
            nodeId: '185',
            label: 'Convert To Date',
            description: '',
            value: 'CDate([expression])',
            usage: 'CDate([expression])',
            childNodes: [],
          },
          {
            nodeId: '186',
            label: 'Convert To Double',
            description: '',
            value: 'CDbl([expression])',
            usage: 'CDbl([expression])',
            childNodes: [],
          },
          {
            nodeId: '187',
            label: 'Convert To Decimal',
            description: '',
            value: 'CDec([expression])',
            usage: 'CDec([expression])',
            childNodes: [],
          },
          {
            nodeId: '188',
            label: 'Convert To Integer',
            description: '',
            value: 'CInt([expression])',
            usage: 'CInt([expression])',
            childNodes: [],
          },
          {
            nodeId: '189',
            label: 'Convert To Lonh',
            description: '',
            value: 'CLng([expression])',
            usage: 'CLng([expression])',
            childNodes: [],
          },
          {
            nodeId: '190',
            label: 'Convert To Object',
            description: '',
            value: 'CObj([expression])',
            usage: 'CObj([expression])',
            childNodes: [],
          },
          {
            nodeId: '191',
            label: 'Convert To Short',
            description: '',
            value: 'CShort([expression])',
            usage: 'CShort([expression])',
            childNodes: [],
          },
          {
            nodeId: '192',
            label: 'Convert To Single',
            description: '',
            value: 'CSng([expression])',
            usage: 'CSng([expression])',
            childNodes: [],
          },
          {
            nodeId: '193',
            label: 'Convert To String',
            description: '',
            value: 'CStr([expression])',
            usage: 'CStr([expression])',
            childNodes: [],
          },
          {
            nodeId: '194',
            label: 'Fix',
            description: '',
            value: 'Fix([expression])',
            usage: 'Fix([expression])',
            childNodes: [],
          },
          {
            nodeId: '195',
            label: 'Hex',
            description: '',
            value: 'Hex([expression])',
            usage: 'Hex([expression])',
            childNodes: [],
          },
          {
            nodeId: '196',
            label: 'Integer to number',
            description: '',
            value: 'Int([expression])',
            usage: 'Int([expression])',
            childNodes: [],
          },
          {
            nodeId: '197',
            label: 'Octal to number',
            description: '',
            value: 'Oct([expression])',
            usage: 'Oct([expression])',
            childNodes: [],
          },
          {
            nodeId: '198',
            label: 'Str',
            description: '',
            value: 'Str([expression])',
            usage: 'Str([expression])',
            childNodes: [],
          },
          {
            nodeId: '199',
            label: 'Val',
            description: '',
            value: 'Val([expression])',
            usage: 'Val([expression])',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '200',
        label: 'Colors',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '201',
            label: 'Red',
            description: '',
            value: '#FF0000',
            usage: '#FF0000',
            childNodes: [],
          },
          {
            nodeId: '202',
            label: 'Green',
            description: '',
            value: '#00FF00',
            usage: '#00FF00',
            childNodes: [],
          },
          {
            nodeId: '203',
            label: 'Blue',
            description: '',
            value: '#0000FF',
            usage: '#0000FF',
            childNodes: [],
          },
          {
            nodeId: '204',
            label: 'White',
            description: '',
            value: '#FFFFFF',
            usage: '#FFFFFF',
            childNodes: [],
          },
          {
            nodeId: '205',
            label: 'Black',
            description: '',
            value: '#000000',
            usage: '#000000',
            childNodes: [],
          },
          {
            nodeId: '206',
            label: 'Pink',
            description: '',
            value: '#FF00CC',
            usage: '#FF00CC',
            childNodes: [],
          },
          {
            nodeId: '207',
            label: 'LightBlue',
            description: '',
            value: '#0066FF',
            usage: '#0066FF',
            childNodes: [],
          },
          {
            nodeId: '208',
            label: 'LightGreen',
            description: '',
            value: '#66FF00',
            usage: '#66FF00',
            childNodes: [],
          },
          {
            nodeId: '209',
            label: 'Gray',
            description: '',
            value: '#C0C0C0',
            usage: '#C0C0C0',
            childNodes: [],
          },
        ],
      },
      {
        nodeId: '210',
        label: 'Miscellaneous',
        description: '',
        value: '',
        usage: '',
        childNodes: [
          {
            nodeId: '211',
            label: 'Level',
            description: '',
            value: 'Level([expression])',
            usage: 'Level([expression])',
            childNodes: [],
          },
          {
            nodeId: '212',
            label: 'Previous',
            description: '',
            value: 'Previous([expression])',
            usage: 'Previous([expression])',
            childNodes: [],
          },
          {
            nodeId: '213',
            label: 'RowNumber',
            description: '',
            value: 'RowNumber("ReportDataset")',
            usage: 'RowNumber("ReportDataset")',
            childNodes: [],
          },
        ],
      },
    ],
  },
];
